import ConfirmButton from "./ConfirmButton/template";
export { ConfirmButton };
